'use client';

import { AppSidebar, SidebarLayout, useSidebar } from '@/components/layout/app-sidebar';
import { AuthForm } from '@/components/auth/auth-modal';
import { LoadingScreen } from '@/components/layout/loading-screen';
import { useAuth } from '@/providers/auth-provider';
import { ChatStreamProvider } from '@/providers/chat-stream-provider';
import { cn } from '@/lib/utils';

function MainContent({ children }: { children: React.ReactNode }) {
  const { isCollapsed } = useSidebar();

  return (
    <div className={cn(
      "transition-all duration-300",
      isCollapsed ? "md:pl-16" : "md:pl-64"
    )}>
      <main className="min-h-[100dvh] px-4 py-4 md:px-6 md:py-6">
        {children}
      </main>
    </div>
  );
}

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return <AuthForm />;
  }

  return (
    <ChatStreamProvider>
      <SidebarLayout>
        <div className="min-h-[100dvh]">
          <AppSidebar />
          <MainContent>{children}</MainContent>
        </div>
      </SidebarLayout>
    </ChatStreamProvider>
  );
}
